import theme from '../../../lib/theme';

const {
  scale,
  layouts,
  media,
  colors,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({
  container: {
    borderTop: `1px solid ${colors.grey}`,
    padding: `${scale.l} ${scale.xs} ${scale.l}`,

    [media.s.up]: {
      padding: `${scale.l} ${scale.s} ${scale.l}`,
      marginTop: `${scale.s}`,
    },

    [media.xl.up]: {
      marginTop: `${scale.m}`,
    },
  },
  columnContainer: {
    ...layouts.column,

    '& > *': {
      marginBottom: scale.l,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'flex-start',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.m,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },

  listContainer: {
    width: '100%',
  },

  title: {
    color: colors.black,
    fontFamily: families.primary,
    fontWeight: font.bold,
    margin: 0,
    fontSize: font.xxl,
    lineHeight: heights.xxl,

    [media.s.up]: {
      fontSize: font.xxxl,
      lineHeight: heights.xxxl,
    },
  },

  num: {
    color: colors.dark_grey,
    fontFamily: families.copy,
    fontSize: font.xxxl,
    lineHeight: heights.xxxl,
    fontStyle: 'italic',
    textAlign: 'start',
  },
});
